import Iconify from "@/src/components/iconify";
import { useCallback } from "react";
import { toast } from "sonner";
import CustomIconButton from "../ui/iconButton";

export const showOtpToast = (otpMessage) => {
    // Function to copy OTP to clipboard
    const handleCopyToClipboard = () => {
        const otp = otpMessage.split("-")[1]?.trim(); // Extract OTP
        if (otp) {
            navigator.clipboard.writeText(otp);
        } else {
            toast.error("Failed to copy OTP.");
        }
    };

    // Display the custom OTP toast
    toast(
        <div style={{ display: "flex", alignItems: "center" }}>
            <span style={{ flex: 1, fontWeight: 500, marginRight: "5px" }}>
                {otpMessage}
            </span>
            <CustomIconButton onClick={handleCopyToClipboard}>
                <Iconify
                    icon={"clarity:copy-to-clipboard-line"}
                    width={24}
                    className="text-primary"
                />
            </CustomIconButton>
        </div>,
        {
            style: {
                background: "#f0f0f0",
                padding: "10px",
                borderRadius: "8px",
            },
        }
    );
};

export const useToast = () => {
    const showCustomToast = useCallback(
        (message, type = "default", options = {}) => {
            switch (type) {
                case "success":
                    toast.success(message, options);
                    break;
                case "error":
                    toast.error(message, options);
                    break;
                case "info":
                    toast.info(message, options);
                    break;
                case "warning":
                    toast.warning(message, options);
                    break;
                default:
                    toast(message, options);
            }
        },
        []
    );

    const showToast = useCallback(
        (data) => {
            if (!data) return;

            const statusCode = data?.status;
            let message;

            switch (statusCode) {
                case 200:
                    message = data?.data?.message || "Success!";
                    showCustomToast(message, "success");
                    break;
                case 409:
                    message =
                        data?.response?.data?.message || "Conflict occurred!";
                    showCustomToast(message, "warning");
                    break;
                default:
                    message =
                        data?.response?.data?.message || "An error occurred!";
                    showCustomToast(message, "error");
            }
        },
        [showCustomToast]
    );

    const showLoadingToast = useCallback((loadingState, options = {}) => {
        const defaultOptions = {
            loading: "Loading...",
            success: "Success!",
            error: "Error occurred!",
        };

        if (loadingState === "loading") {
            toast.loading(defaultOptions.loading, {
                ...defaultOptions,
                ...options,
            });
        } else if (loadingState === "success") {
            toast.success(defaultOptions.success, { ...options });
        } else if (loadingState === "error") {
            toast.error(defaultOptions.error, { ...options });
        }
    }, []);

    return { showCustomToast, showToast, showLoadingToast };
};

//   const handleSuccess = () => {
//     showCustomToast("This is a success message", "success");
//   };
